export default __webpack_public_path__ + "static/media/animesearch.88d3f3b8.jpg";